import React from 'react';
import brakeShoe from '../../images/brakeshoe.png';
import brakeShoeFilling from '../../images/bs_filling.gif';
import brakeShoeSolid from '../../images/bs_solidification.gif';

const BrakeshoeDesign = () => {
  return (
    <div className="flex flex-col md:flex-row justify-around items-center flex-wrap h-full font-sans py-32">
      <div className="flex flex-col md:flex-row items-center gap-5 mb-5 md:mb-0">
        <div className="shadow-lg p-5 bg-gray-600  h-auto transform hover:scale-105 transition-transform duration-200 ease-in-out">
          <img src={brakeShoe} alt="Brake Shoe" className="w-[500px] h-[400px]" />
          <h2 className="text-xl font-bold text-gray-100 text-center mt-6">Brake Shoe</h2>
        </div>
        <div className="flex flex-col md:flex-row gap-5">
          <div className="shadow-lg p-5  bg-gray-600 h-auto transform hover:scale-105 transition-transform duration-200 ease-in-out">
            <img src={brakeShoeFilling} alt="Brake Shoe Filling GIF" className="w-[500px] h-[400px]" />
            <h2 className="text-xl font-bold text-gray-100 text-center mt-6">Brake Shoe Filling</h2>
          </div>
          <div className="shadow-lg p-5  bg-gray-600 h-auto transform hover:scale-105 transition-transform duration-200 ease-in-out">
            <img src={brakeShoeSolid} alt="Brake Shoe Solidification GIF" className="w-[500px] h-[400px]" />
            <h2 className="text-xl font-bold text-gray-100 text-center mt-6">Brake Shoe Solidification</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrakeshoeDesign;
